
import { defineComponent } from 'vue'
import ProviderCard from './ProviderCard.vue'

type Partner = {
  name: string,
  slug: string,
  logo: string,
}

export default defineComponent({
  name: 'ProvidersDeals',
  components: {
    ProviderCard,
  },
  setup () {
    const partners: Partner[] = [
      {
        name: 'Swisscom',
        slug: 'swisscom',
        logo: require('~/assets/images/provider-logos/v7/white/Swisscom.svg'),
      },
      {
        name: 'Wingo',
        slug: 'wingo',
        logo: require('~/assets/images/provider-logos/v7/white/Wingo.svg'),
      },
      {
        name: 'Salt',
        slug: 'salt',
        logo: require('~/assets/images/provider-logos/v7/white/Salt.svg'),
      },
      {
        name: 'Yallo',
        slug: 'yallo',
        logo: require('~/assets/images/provider-logos/v7/white/yallo.svg'),
      },
      {
        name: 'Migros Mobile',
        slug: 'migros-mobile',
        logo: require('~/assets/images/provider-logos/v7/white/migros.svg'),
      },
      {
        name: 'Quickline',
        slug: 'quickline',
        logo: require('~/assets/images/provider-logos/v7/white/Quickline.svg'),
      },
      {
        name: 'TalkTalk',
        slug: 'talktalk',
        logo: require('~/assets/images/provider-logos/v7/white/TalkTalk.svg'),
      },
    ]

    return {
      partners,
    }
  },
})
